import Model, { attr, hasMany } from '@ember-data/model'
import { Type } from '@warp-drive/core-types/symbols'
import type PartnerContactDetail from 'teacher-ui-client/models/partner-contact-detail'
import type SchoolPartner from 'teacher-ui-client/models/school-partner'
import type { PartnerCode } from 'teacher-ui-client/partner/partners'
import type StringTransform from 'teacher-ui-client/transforms/string'

export default class Partner extends Model {
  @attr<StringTransform>('string') declare name: string

  @attr<StringTransform>('string') declare code: PartnerCode

  @hasMany<SchoolPartner>('school-partner', { async: false, inverse: 'partner' })
  declare schoolPartners?: SchoolPartner[]

  // 1 for each subtype
  @hasMany<PartnerContactDetail>('partner-contact-detail', { async: false, inverse: 'partner' })
  declare partnerContactDetails?: PartnerContactDetail[];

  [Type] = 'partner' as const
}
